module.exports = __webpack_public_path__ + "static/img/IMG_20160308_131934.6b9adb33.jpg";